import uuid4 from 'uuid4';

const PREFIX = `jirango_onsite_`;

// const storage = {
//   setDeviceId: (id?: string) => {
//     window.localStorage.setItem(`${APP_PREFIX}deviceId`, id ?? uuid4());
//   },
//   getDeviceId: () => {
//     return window.localStorage.getItem(`${APP_PREFIX}deviceId`);
//   },
//   getAccessToken: () => {
//     return JSON.parse(window.localStorage.getItem(`${APP_PREFIX}token`) as string);
//   },
//   setAccessToken: (token: string) => {
//     window.localStorage.setItem(`${APP_PREFIX}token`, JSON.stringify(token));
//   },
//   removeAccessToken: () => {
//     window.localStorage.removeItem(`${APP_PREFIX}token`);
//   },
// };

const listeners = new Set<() => void>();

export function removeItem(key: string) {
  localStorage.removeItem(key);
  listeners.forEach(cb => cb());
}

export function getSnapshot(key: string) {
  const value = localStorage.getItem(key);
  return value;
}

export function subscribe(callback: () => void) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function setItem(key: string, value: string) {
  localStorage.setItem(key, value);
  listeners.forEach(cb => cb());
}

export default {
  getAccessToken: () => {
    return getSnapshot(PREFIX + 'access_token');
  },
  setAccessToken: (token: string) => {
    setItem(PREFIX + 'access_token', token);
  },
  removeAccessToken: () => {
    removeItem(PREFIX + 'access_token');
  },
  getAccessTokenKey: () => {
    return PREFIX + 'access_token';
  },
  setDeviceId: (id?: string) => {
    window.localStorage.setItem(`${PREFIX}deviceId`, id ?? uuid4());
  },
  getDeviceId: () => {
    return window.localStorage.getItem(`${PREFIX}deviceId`);
  },
};
